import * as React from 'react';

import Input from 'src/components/common/Input';

import AccountBillService from 'src/services/account/accountBillService';
import UserModel from 'src/model/user.model';

import { goToAccount } from 'src/utils/navigation';
import './BillingAddress.scss';
import Loader from '../common/Loader';
import env from 'src/shared/env';
import i18n from 'src/translation/i18n';

interface IValidation {
  invalid: boolean;
  message: string;
}

interface IBillingAddressProps {
  userData: UserModel;
  onLoad(): void;
  t?: any;
}

interface IBillingAddressState {
  fullBillingName: string;
  requesterName: string;
  address: string;
  addressOptional: string;
  country: string;
  state: string;
  city: string;
  zipCode: string;
  fullBillingNameValidation: IValidation;
  requesterNameValidation: IValidation;
  addressValidation: IValidation;
  countryValidation: IValidation;
  stateValidation: IValidation;
  cityValidation: IValidation;
  zipCodeValidation: IValidation;
  enableRequest: boolean;
  requestSent: boolean;
  succed: boolean;
  failed: boolean;
  loading: boolean;
}

class BillingAddress extends React.Component<
  IBillingAddressProps,
  IBillingAddressState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      fullBillingName: '',
      requesterName: '',
      address: '',
      addressOptional: '',
      country: '',
      state: '',
      city: '',
      zipCode: '',
      fullBillingNameValidation: { invalid: false, message: '' },
      requesterNameValidation: { invalid: false, message: '' },
      addressValidation: { invalid: false, message: '' },
      countryValidation: { invalid: false, message: '' },
      stateValidation: { invalid: false, message: '' },
      cityValidation: { invalid: false, message: '' },
      zipCodeValidation: { invalid: false, message: '' },
      enableRequest: true,
      requestSent: false,
      succed: false,
      failed: false,
      loading: false
    };
  }

  private validateForm = () => {
    const INVALID_MSG = `${i18n.t('common.fieldRequiredTxt')}`;

    const {
      fullBillingName,
      requesterName,
      address,
      country,
      state,
      city,
      zipCode
    } = this.state;
    const fields = {
      fullBillingName,
      requesterName,
      address,
      country,
      state,
      city,
      zipCode
    };
    const validations: any = {};

    for (const key in fields) {
      if (!fields[key].length) {
        validations[`${key}Validation`] = {
          invalid: true,
          message: INVALID_MSG
        };
      } else {
        validations[`${key}Validation`] = { invalid: false, message: '' };
      }
    }

    const enableRequest = Object.keys(validations).reduce(
      (total, item: any) => total && !item.invalid,
      true
    );

    this.setState({
      ...validations,
      enableRequest
    });
  };

  private handlefullBillingNameChange = (fullBillingName: string) => {
    if (fullBillingName === '') {
      this.setState({
        fullBillingName,
        fullBillingNameValidation: {
          invalid: true,
          message: `${i18n.t('common.fieldRequiredTxt')}`
        },
        enableRequest: false
      });
    } else {
      this.setState({
        fullBillingName,
        fullBillingNameValidation: {
          invalid: false,
          message: ''
        },
        enableRequest: true
      });
    }
  };

  private handlerequesterNameChange = (requesterName: string) => {
    if (requesterName === '') {
      this.setState({
        requesterName,
        requesterNameValidation: {
          invalid: true,
          message: `${i18n.t('common.fieldRequiredTxt')}`
        },
        enableRequest: false
      });
    } else {
      this.setState({
        requesterName,
        requesterNameValidation: {
          invalid: false,
          message: ''
        },
        enableRequest: true
      });
    }
  };

  private handleAddressChange = (address: string) => {
    if (address === '') {
      this.setState({
        address,
        addressValidation: {
          invalid: true,
          message: `${i18n.t('common.fieldRequiredTxt')}`
        },
        enableRequest: false
      });
    } else {
      this.setState({
        address,
        addressValidation: {
          invalid: false,
          message: ''
        },
        enableRequest: true
      });
    }
  };

  private handleAddressOptionalChange = (addressOptional: string) => {
    this.setState({ addressOptional });
  };

  private handleCountryChange = (country: string) => {
    if (country === '') {
      this.setState({
        country,
        countryValidation: {
          invalid: true,
          message: `${i18n.t('common.fieldRequiredTxt')}`
        },
        enableRequest: false
      });
    } else {
      this.setState({
        country,
        countryValidation: {
          invalid: false,
          message: ''
        },
        enableRequest: true
      });
    }
  };

  private handleStateChange = (state: string) => {
    if (state === '') {
      this.setState({
        state,
        stateValidation: {
          invalid: true,
          message: `${i18n.t('common.fieldRequiredTxt')}`
        },
        enableRequest: false
      });
    } else {
      this.setState({
        state,
        stateValidation: {
          invalid: false,
          message: ''
        },
        enableRequest: true
      });
    }
  };

  private handleCityChange = (city: string) => {
    if (city === '') {
      this.setState({
        city,
        cityValidation: {
          invalid: true,
          message: `${i18n.t('common.fieldRequiredTxt')}`
        },
        enableRequest: false
      });
    } else {
      this.setState({
        city,
        cityValidation: {
          invalid: false,
          message: ''
        },
        enableRequest: true
      });
    }
  };

  private handleZipCodeChange = (zipCode: string) => {
    if (zipCode === '') {
      this.setState({
        zipCode,
        zipCodeValidation: {
          invalid: true,
          message: `${i18n.t('common.fieldRequiredTxt')}`
        },
        enableRequest: false
      });
    } else {
      this.setState({
        zipCode,
        zipCodeValidation: {
          invalid: false,
          message: ''
        },
        enableRequest: true
      });
    }
  };

  private handleRequestChange = () => {
    this.setState({ loading: true }, () => {
      AccountBillService.changeBillAddress({
        address: this.state.address,
        address2: this.state.addressOptional,
        city: this.state.city,
        country: this.state.country,
        fullBillingName: this.state.fullBillingName,
        requesterName: this.state.requesterName,
        state: this.state.state,
        zipCode: this.state.zipCode,
        customerNumber: this.props.userData.clientIdentity
      })
        .then(res =>
          this.setState({ requestSent: true, succed: true, loading: false })
        )
        .catch(err =>
          this.setState({ requestSent: true, failed: true, loading: false })
        );
    });
  };

  private handleCloseAlert = () => {
    if (this.state.succed) {
      goToAccount();
    } else {
      this.setState({ requestSent: false, succed: false, failed: false });
    }
  };

  public componentDidUpdate(prevProps: IBillingAddressProps) {
    if (
      prevProps.userData.billingAddress !== this.props.userData.billingAddress
    ) {
      this.setState(
        {
          fullBillingName: this.props.userData.billingAddress.name,
          address: `${this.props.userData.billingAddress.addressLine1} ${this.props.userData.billingAddress.addressLine2} ${this.props.userData.billingAddress.addressLine3}`,
          country: this.props.userData.billingAddress.country,
          state: this.props.userData.billingAddress.stateCode,
          city: this.props.userData.billingAddress.addressLine4,
          zipCode: this.props.userData.billingAddress.postalCode
        },
        () => this.validateForm()
      );
    }
  }

  public componentDidMount() {
    this.props.onLoad();
    // this.validateForm();
  }

  private renderForm = () => {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className="rp-billing-address-title">
          {t('accountInfo.requestBillingAddressChange')}
        </div>
        <div className="rp-billing-address-form">
          <Input
            label={`*${t('accountInfo.fullBillingName')}:`}
            value={this.state.fullBillingName}
            onChange={this.handlefullBillingNameChange}
            invalid={this.state.fullBillingNameValidation.invalid}
            invalidMessage={this.state.fullBillingNameValidation.message}
          />
          <Input
            label={`*${t('accountInfo.nameOfPersonRequesting')}:`}
            value={this.state.requesterName}
            onChange={this.handlerequesterNameChange}
            invalid={this.state.requesterNameValidation.invalid}
            invalidMessage={this.state.requesterNameValidation.message}
          />
          <Input
            label={`*${t('accountShippingAddress.address')}:`}
            placeholder={`*${t('accountShippingAddress.addressPlaceholder')}:`}
            value={this.state.address}
            onChange={this.handleAddressChange}
            invalid={this.state.addressValidation.invalid}
            invalidMessage={this.state.addressValidation.message}
          />
          <Input
            value={this.state.addressOptional}
            placeholder={`*${t('accountShippingAddress.suiteTxt')}:`}
            onChange={this.handleAddressOptionalChange}
          />
          <Input
            label={`*${t('accountShippingAddress.city')}:`}
            value={this.state.city}
            onChange={this.handleCityChange}
            invalid={this.state.cityValidation.invalid}
            invalidMessage={this.state.cityValidation.message}
          />
          <Input
            label={`*${t('accountShippingAddress.stateOrProvince')}:`}
            value={this.state.state}
            onChange={this.handleStateChange}
            invalid={this.state.stateValidation.invalid}
            invalidMessage={this.state.stateValidation.message}
          />
          <Input
            label={
              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                ? `*${t('accountShippingAddress.postalCode')}:`
                : `*${t('accountShippingAddress.zipOrPostal')}:`
            }
            value={this.state.zipCode}
            onChange={this.handleZipCodeChange}
            invalid={this.state.zipCodeValidation.invalid}
            invalidMessage={this.state.cityValidation.message}
          />
          <Input
            label={`*${t('accountShippingAddress.country')}:`}
            value={this.state.country}
            onChange={this.handleCountryChange}
            invalid={this.state.countryValidation.invalid}
            invalidMessage={this.state.countryValidation.message}
          />
        </div>
        <div className="rp-billing-address-buttons">
          <button className="secondary-button" onClick={e => goToAccount()}>
            {t('common.cancel')}
          </button>
          <button
            className="primary-button"
            onClick={e => this.handleRequestChange()}
            disabled={!this.state.enableRequest}
          >
            {t('accountInfo.requestChange')}
          </button>
        </div>
      </React.Fragment>
    );
  };

  private renderRequestSent = () => {
    const { t } = this.props;
    return (
      <div className="rp-billing-address--sent">
        <div className="rp-billing-address--sent-info">
          {this.state.succed ? (
            <span className="rpds-check-circle rp-billing-address--sent-icon-success" />
          ) : (
            <span className="rpds-error rp-billing-address--sent-icon-failure" />
          )}
          <section>
            <div className="rp-billing-address--sent-title">
              {this.state.succed
                ? `${t('accountShippingAddress.requestSentSuccessHeading')}`
                : `${t('accountShippingAddress.requestNotSentTxt')}`}
            </div>
            <div className="rp-billing-address--sent-text">
              {this.state.succed
                ? `${t('accountShippingAddress.requestSentSuccessTxt')}`
                : `${t('accountShippingAddress.requestProblem')}`}
            </div>
          </section>
        </div>
        <div className="rp-billing-address--sent-divider" />
        <button
          className="primary-button rp-billing-address--sent-button"
          onClick={e => this.handleCloseAlert()}
        >
          {this.state.succed
            ? `${t('common.continueActionTxt')}`
            : `${t('common.tryAgainActionTxt')}`}
        </button>
      </div>
    );
  };

  public render() {
    return (
      <div className="rp-billing-address">
        {this.state.loading ? <Loader /> : null}
        {this.state.requestSent ? this.renderRequestSent() : this.renderForm()}
      </div>
    );
  }
}

export default BillingAddress;
